export default "__VITE_ASSET__361731ef__"